import { connect } from 'react-redux';
import DashboardModal from '../../components/DashboardModal/DashboardModal';
import { setDashboardModalVisibility } from '../../actions/DashboardActions';
import { selectFeature } from '../../actions/selectors';

const mapStateToProps = (state) => ({
  open: state.leaksList.dashboard.modalVisible,
  selectedProject: state.leaksList.selectedProject,
  leaksData: state.leaksList.leaksByProject,
  user: state.user
});

const mapDispatchToProps = {
  onClose: () => setDashboardModalVisibility(false)
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardModal);